import React from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./BasePortalPageHeader.module.scss";
import Menu, { MenuItem, MenuThemes } from "@src/components/common/Menu";
import UserDisplay from "@src/components/common/UserDisplay";
import * as AuthApi from "@src/api/AuthApi";
import { addStaticRootToUrl } from "@src/utils/static";
import MaxWidthContainer from "@src/components/containers/MaxWidthContainer";
import NotificationBell from "@src/components/common/NotificationBell";
import { useCurrentUserStore } from "@src/state/currentUserState";

export default function BasePortalPageHeader() {
  const navigate = useNavigate();
  const { currentUser } = useCurrentUserStore();

  const handleLogout = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const response = await AuthApi.logoutUser();
    if (response.status === 200) {
      navigate(0);
    }
  };

  return (
    <MaxWidthContainer className={styles.root}>
      <header className="flex-row flex-center space-between">
        <Link className={styles.homepageLink} to="/">
          <img
            src={addStaticRootToUrl("images/logo_colored.png")}
            alt="OrderEasy Logo"
          />
        </Link>

        <div className={styles.actionDropdowns}>
          <NotificationBell className={styles.dropdownButton} />

          <Menu
            buttonContent={
              <div
                id="page-header-user-menu-button"
                data-testid="page-header-user-menu-button"
                className={styles.dropdownButton}
              >
                <i className="fa-light fa-user" />
              </div>
            }
            theme={MenuThemes.Options}
          >
            <MenuItem viewOnly>
              <UserDisplay
                initialUserDisplayInfo={currentUser}
                isForCurrentUser
              />
            </MenuItem>
            <MenuItem>
              <Link
                id="page-header-account-settings-link"
                data-testid="page-header-account-settings-link"
                to="/account/general"
              >
                Account Settings
              </Link>
            </MenuItem>
            <MenuItem>
              <a
                id="logout-link"
                data-testid="page-header-logout-link"
                href="/logout"
                onClick={handleLogout}
              >
                Log Out
              </a>
            </MenuItem>
          </Menu>
        </div>
      </header>
    </MaxWidthContainer>
  );
}
